export default (completionHandler = () => {}) => ({
  onResolve: (...args) => { completionHandler(undefined, ...args); },
  onReject: (...args) => { completionHandler(...args); },
});
